import React from "react";
import BaseComponent from "../BaseComponent";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import moment from "moment";

import NanoFlex from "../Global/NanoFlex";

const StyledInputDate = styled.div`
  .inputDateWapprer {
    border: 1px solid ${nota.color.neutral.NeuTwo};
    padding: 8px 6px;
    .inputContainer {
      input {
        border: none;
        text-align: center;
        width: 100%;
        color: ${nota.color.neutral.NeuOne};
        padding: 0;
        &::placeholder {
          color: ${nota.color.neutral.NeuTwo};
          font-size: 11px;
        }
      }
      .inputYear {
        width: 38px;
      }

      &:after {
        content: "/";
        display: block;
        font-size: 12px;
        color: ${nota.color.neutral.NeuTwo};
      }
      &:last-child {
        &:after {
          display: none;
        }
      }
    }
  }
`;

class InputDate extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      momentDate: props.date ? moment(props.date, nota.global.moment.serverDate) : null,
    };

    this.preventOnDateChange = false;
    this.canMove = true;
    this.dateInput = React.createRef();
    // this.dayInput = React.createRef();
    // this.monthInput = React.createRef();
    // this.yearInput = React.createRef();
  }

  componentDidMount() {
    super.componentDidMount();
    this.setInputsFromState();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.date !== this.props.date) {
      this.preventOnDateChange = true;
      this.setState({ momentDate: this.props.date ? moment(this.props.date, nota.global.moment.serverDate) : null }, () => {
        this.preventOnDateChange = false;
      });
    }

    if (this.state.momentDate !== prevState.momentDate) {
      this.setInputsFromState();
      if (this.props.onDateChange && !this.preventOnDateChange) {
        this.props.onDateChange(this.state.momentDate ? this.state.momentDate.format(nota.global.moment.serverDate) : null);
      }
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  setInputsFromState = () => {
    if (this.state.momentDate) {
      this.dateInput.current.value = this.state.momentDate.format(this.getDateOutputFormat());
    } else {
      this.dateInput.current.value = "";
    }
  };

  onBlur = (e) => {
    //If Value is Null set momentDate as null
    if (!e.target.value) {
      this.setState({ momentDate: null });
      return;
    }

    let date = this.state.momentDate ? moment(this.state.momentDate) : null;
    if (!date) {
      date = moment().set("date", 1).set("month", 0);
    }

    this.getDateInputFormats().forEach((v) => {
      date = moment(e.target.value, v);
      if (!date.isValid()) {
        date = null;
      } else {
        return;
      }
    });

    this.setState({ momentDate: date }, () => {
      if (!this.state.momentDate) {
        this.dateInput.current.value = "";
      }
    });
  };

  render() {
    return (
      <StyledInputDate className="inputDateContainer">
        <NanoFlex className="inputDateWapprer">
          <NanoFlex className="inputContainer">
            <input
              ref={this.dateInput}
              type="text"
              placeholder={this.getDateOutputFormat()}
              maxLength="10"
              onBlur={(e) => {
                this.onBlur(e);
              }}
            />
          </NanoFlex>
        </NanoFlex>
      </StyledInputDate>
    );
  }
}

// Set default props
InputDate.defaultProps = {};

export default InputDate;

// --- // Documentation // --- //
/*
import InputDate from './../Nano/InputDate.js';

<InputDate />
*/
